import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {

  1: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P23-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page23/E1/Key/Key.PNG',
    titleImage: '',
    isAllowSubmit: true,
    questionImage: [ // Row
      [
        // Column 1
        { url: 'img/FriendsPlus/Page23/E1/1.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page23/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/3.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E1/4.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page23/E1/5.jpg', input: 2 },
      ],
      [
        // Column 2

        { url: 'img/FriendsPlus/Page23/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/7.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E1/8.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page23/E1/9.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page23/E1/10.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page23/E1/11.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page23/E1/12.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E1/13.jpg' },
      ],
    ],
  },

  2: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P23-E2',
    audio: 'img/FriendsPlus/Page23/Audio/audio-e2-p23.mp3',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page23/E2/Key/Key.PNG',
    titleImage: '',
    isAllowSubmit: true,
    questionImage: [ // Row
      [
        // Column 1
        { url: 'img/FriendsPlus/Page23/E2/1a.jpg' },
        { url: 'img/FriendsPlus/Page23/E2/1b.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/tieude-e2-p23.mp3' },
        { url: 'img/FriendsPlus/Page23/E2/1c.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page23/E2/2a.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page23/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page23/E2/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page23/E2/4.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E2/5.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page23/E2/6.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page23/E2/7.jpg' },
      ],
      [
        // Column 2
        { url: 'img/FriendsPlus/Page23/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page23/E2/9.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page23/E2/10.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E2/11.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page23/E2/12.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page23/E2/13.jpg' },
      ],
      [
        // Column 2
        { url: 'img/FriendsPlus/Page23/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page23/E2/15.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page23/E2/16.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page23/E2/17.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E2/18.jpg' },
      ],
      [
        // Column 1
        { url: 'img/FriendsPlus/Page23/E2/19.jpg' },
      ],
    ],
  },

  3: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P22-E3',
    audio: '',
    video: '',
    component: D1,
    inputHeight: 35,
    isAllowSubmit: true,
    // maxLength: 3,
    // fontSize: 20,
    textAlign: 'left',
    padding: 0,
    exerciseKey: 'img/FriendsPlus/Page23/E3/Key/Key.PNG',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/3.jpg', input: true, answer: "bread" },
        { url: 'img/FriendsPlus/Page23/E3/4.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E3/5.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/7.jpg', input: true, answer: "juice" },
        { url: 'img/FriendsPlus/Page23/E3/8.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E3/9.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/11.jpg', input: true, answer: "grass" },
        { url: 'img/FriendsPlus/Page23/E3/12.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E3/13.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/15.jpg', input: true, answer: "frisbee" },
        { url: 'img/FriendsPlus/Page23/E3/16.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E3/17.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/19.jpg', input: true, answer: "friends" },
        { url: 'img/FriendsPlus/Page23/E3/20.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E3/21.jpg' },
      ],
    ]
  },


}

export default json;